export default "__VITE_ASSET__B479FgPS__"